import { render, staticRenderFns } from "./Adicionar.vue?vue&type=template&id=5c305612&scoped=true&"
import script from "./Adicionar.vue?vue&type=script&lang=js&"
export * from "./Adicionar.vue?vue&type=script&lang=js&"
import style0 from "./Adicionar.vue?vue&type=style&index=0&id=5c305612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c305612",
  null
  
)

export default component.exports